//equalHeight
function eqHeight() {
    $.fn.extend({
        equalHeights: function () {
            var top = 0;
            var row = [];
            var classname = ('equalHeights' + Math.random()).replace('.', '');
            $(this).each(function () {
                var thistop = $(this).offset().top;
                if (thistop > top) {
                    $('.' + classname).removeClass(classname);
                    top = thistop;
                }
                $(this).addClass(classname);
                $(this).height('auto');
                var h = (Math.max.apply(null, $('.' + classname).map(function () {
                    return $(this).height();
                }).get()));
                $('.' + classname).height(h);
            }).removeClass(classname);
        }
    });
    if($(window).width() > 768){
        $(".card-grid .card-cell .card-header").equalHeights();
    }

}


$(document).ready(function() {

    eqHeight();

    $(document).on("click", "a[href='#']", function(e) {
        e.preventDefault();
    });
    //custom dropdown
    $('select').formSelect();


    /*mobile menu*/
    $(document).on("click", ".hamburger-menu", function(event) {
        $("html").toggleClass('menu-open');
    });


    // copied-button
    $(".btn-copied").hide();
    $(document).on("click", ".btn-url", function() {
        $(".btn-url").css("pointer-events", "none")
        $(this).fadeOut(400, function() {
            $(this).next().fadeIn(400, function() {
                $(this).delay(2000).fadeOut(400, function() {
                    $(this).prev().fadeIn(400);
                    $(".btn-url").css("pointer-events", "auto")
                });
            });
        });
    });


    //set filter width
    $(document).on("change", ".select-wrapper select", function() { 
        // alert()
        setTimeout(function(){
            $(this).closest(".select-wrapper").find("input.select-dropdown").css("width", $(this).closest(".select-wrapper").find("li.selected span").outerWidth());
        }, 2000)
    });

    // setting switch checked
    $(document).on("change", ".mdc-switch__native-control", function() {
        if ($(this).is(":checked")) {
            $(this).closest(".mdc-card").removeClass('mdc-card-disabled');
        } else {
            $(this).closest(".mdc-card").addClass('mdc-card-disabled');
        }
    });

//    var date = new Date(2018, 01, 02);
//    //datepicker
//    $('.datepicker-btn').datepicker({
//        setDefaultDate: true,
//        defaultDate: date,
//        autoClose: true,
//        format: 'dd-mm-yyyy',
//        onOpen: function() {
//            alert("Here");
//            $("body").addClass('datepicker-open')
//        },
//        onClose: function() {
//            $("body").removeClass('datepicker-open');
//            $(".date-value").text($('.datepicker-btn').val());
//        }
//    });

    //radio checked
   //  $("body").on("click", ".step-btn-next", function(){ 
   //     $('body').on("change",'.dead-line-wrap input:radio', function() {
   //      alert('hello');
   //      if ($(this).is(":checked")) {
   //          $(".label-wrap label").removeClass('checked')
   //          $(this).closest("label").addClass('checked')
   //      }
   //  });
   // });
    //login page
    $(document).on('click', ".forgot-password-link", function(event) {
        $(".login-form").fadeOut(function() {
            $(".forgot-password-form").fadeIn();
        });
    });

    $(document).on('click', ".back-to-login-link", function(event) {
        $(".forgot-password-form").fadeOut(function() {
            $(".login-form").fadeIn();
        });
    });


    $(document).on("click", ".code-modal-btn", function() {
        $("#invite-code-modal").modal("open");
    });
    //close sidebar on tab select mobile
    $(document).on('click', "aside .mdc-tab", function(event) {
        $("html").removeClass('menu-open');
    });

});

$(window).on("load", function(event) {

    eqHeight();

    if ($(".client-view-page").length) {
        $(".client-view-page").addClass('start-animation')
    }
    $("#invite-code-modal").modal({
        endingTop: "12.5%"
    });
    if ($(".side-tab-bar").length) {
        //side bar indicatop
        var top_distance = $(".side-tab-bar .mdc-tab.mdc-tab--active").position().top;
    }
    $(".side-tab-indicator").css("top", top_distance);
    $(".side-tab-bar .mdc-tab").on("click", function(event) {
        var top_distance = $(this).position().top;
        $(".side-tab-indicator").css("top", top_distance);
    });

});
$(window).resize(function(){
    eqHeight();
});

function update_spinner(request, transport)
{
    if ($.active < 0) $.active = 0;
    if ($.active > 0)
    {
         $('.loader').addClass('loader-active');
    }
    else
    {
       $('.loader').removeClass('loader-active');
    }
}
$(document).ajaxComplete(function(event, xhr, settings)
{
    $.active--;
    update_spinner();
});
$(document).ajaxStart(function(event, xhr, settings)
{
   update_spinner();
});
$(document).ajaxSend(function(event, xhr, settings)
{
    $.active++;
    update_spinner();
});
$(document).ajaxError(function(event, xhr, settings)
{
    $.active--;
    update_spinner();
});
setInterval(function(){
	if($.active <= 0){
		update_spinner();
	}
}, 1000);
